<script setup lang="ts">
import ScaleMenuState from "@/stores/ScaleMenuState";
import ForceTextInput from "@/components/UI/form/ForceTextInput.vue";
</script>
<template>
  <li>
    <hr class="dropdown-divider" />
  </li>
  <!-- 6px + le padding de la carte = le retrait des entrées du menu -->
  <li class="px-1">
    <ForceTextInput
      v-model="ScaleMenuState.forcedSize"
      v-model:forced="ScaleMenuState.isTextsizeForced"
      :label="$t('canvas:settings.scale.force.header')"
      :initial-value="ScaleMenuState.activeScaleSize()"
      @change="ScaleMenuState.forceTextsize()"
    />
  </li>
</template>
